/**
 * 原生开户
 * 目前适用于随手记
 */
import useragent from '@common/useragent'
import domain from '@common/domain'
import { absUrl } from '@common/host'
import { call, uriSuishouji } from './bridge'

/**
 * callback: 开户完成的回调函数
 */
export default (callback) => {
  if (useragent.isSuishouji) {
    const bounsUrl = absUrl('/public-op/html/bouns/bouns.html')
    call(uriSuishouji('requestOpenFinanceAccount', {
      url: `${domain.mkt}/market/p2p/register/enter`,
      redirectUrl: bounsUrl
    }), 'appAccountCallback', (jsonResult) => {
      callback(JSON.parse(jsonResult))
    })
  }
}



// WEBPACK FOOTER //
// ./node_modules/@common/client/src/requestOpenFinanceAccount.js